if (!customElements.get("brands-marquee-controls")) {
  customElements.define(
    "brands-marquee-controls",
    class BrandsMarqueeControls extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.marqueeContainer = this.querySelector(".wt-brands__marquee");
        this.controlButton = this.querySelector(".wt-brands__control-button");

        if (!this.marqueeContainer || !this.controlButton) return;

        this.isPlaying = true;
        this.togglePlayPause = this.togglePlayPause.bind(this);
        this.controlButton.addEventListener("click", this.togglePlayPause);
      }

      togglePlayPause() {
        this.isPlaying = !this.isPlaying;

        this.marqueeContainer.classList.toggle(
          "wt-brands__marquee--paused",
          !this.isPlaying
        );

        this.controlButton.classList.toggle(
          "wt-brands__control-button--play",
          this.isPlaying
        );
        this.controlButton.classList.toggle(
          "wt-brands__control-button--pause",
          !this.isPlaying
        );
      }

      disconnectedCallback() {
        if (this.controlButton) {
          this.controlButton.removeEventListener("click", this.togglePlayPause);
        }
      }
    }
  );
}